const ProductPage = (data) => {
    if (!window.eS) return;

    const generalInfo = {};
    if (window.phone) generalInfo.user_phone = window.phone;
    if (window.email) generalInfo.user_email = window.email;

    window.eS('sendEvent', 'ProductPage', {
        'ProductPage': {
            // 'productKey': '24-MB02',            
            // 'price': '153',
            // 'isInStock': 1,
            // 'tag_some_field': ['123'],
            // 'tag_another_field': ['321', '213']
            ...data
        },
        'GeneralInfo': {
            ...generalInfo
        }
    });
}

export default ProductPage;